<template>
  <section class="main-content">
    <h3 class="title"> {{contents.title}}</h3>
    <p class="author">{{contents.author}}
      <span class="time" v-html="contents.published_at"></span>
    </p>
    <article class="content"  v-html="contents.content">
    </article>
  </section>
</template>
<script>
  import {mapGetters} from 'vuex'
  import {get} from '../../api/utils/dom'
  import Lazy from '../../api/utils/lazyLoad'
  import {loadVideo} from '../../api/utils/funcs'
  let lazy
  let winH = window.innerHeight
  export default {
    name: 'main-news',
    computed: {
      ...mapGetters(['contents'])
    },
    mounted: function () {
      this.$nextTick(function () {
        //加载视频
        loadVideo();
        let contentDom = get('.content')
        let moreDom = get('.more-btn')
        let twoH = 1.5 * winH
        if (contentDom.scrollHeight > twoH) {
          moreDom.parentNode.style.display = 'block'
          contentDom.style.height = twoH + 'px'
          moreDom.onclick = function (e) {
            e.preventDefault()
            contentDom.style.height = 'auto'
            moreDom.parentNode.style.display = 'none'
          }
        } else {
          moreDom.parentNode.style.display = 'none'
        }
        lazy = new Lazy({
          parent: contentDom
        }, 200)
      })
    },
    updated: function () {
      let k = this
      k.$nextTick(function () {
        //加载视频
        loadVideo();
        let contentDom = get('.content')
        let moreDom = get('.more-btn')
        let twoH = 1.5 * winH
        if (contentDom.scrollHeight > twoH) {
          moreDom.parentNode.style.display = 'block'
          contentDom.style.height = twoH + 'px'
          moreDom.onclick = null
          moreDom.onclick = function (e) {
            e.preventDefault()
            contentDom.style.height = 'auto'
            moreDom.parentNode.style.display = 'none'
          }
        } else {
          moreDom.parentNode.style.display = 'none'
        }

        if (lazy) {
          lazy.reset()
        }
        let keyDom = get('#metaKey')
        let descDom = get('#metaDesc')
        let titleDom = document.querySelector('title')

        keyDom.innerHTML = k.contents.title
        descDom.innerHTML = k.contents.title
        titleDom.innerHTML = k.contents.title
        k.$emit('hideLoading')
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/article/content-main.vue